module.exports = __webpack_public_path__ + "media/images/tailwind/icon-stroke-up-8ebd85547c9bee6cf04fd2dfc762ab64.png";